<template>
  <div class="app-container">
		<el-card class="tabBox">
		  <el-tabs v-model="activeName" >
		    <el-tab-pane label="消息列表" name="list">
		      <listTab :id="id" :name="activeName"></listTab>
				</el-tab-pane>
		    <el-tab-pane label="消息模板" name="model">
		      <modelTab :id="info.memberId" :name="activeName"></modelTab>
				</el-tab-pane>
		  </el-tabs>
		</el-card>
   
  </div>
</template>

<script>
import listTab from './tabs/list.vue'
import modelTab from './tabs/model.vue'
export default {
  name: "msgList",
  components: {
    listTab,modelTab
  },
  data() {
    return {
		activeName:'list',
		info: {
		  // memberId: 7
		},
	};
  },
  created() {
	  this.id = this.$route.query.id;
  },
  methods: {
	  
  },
};
</script>

<style lang="scss">

</style>

